import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo.jpg';
const _withScopeId = n => (_pushScopeId("data-v-0c42c114"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "wrapper"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "logo",
  id: "logo"
})], -1));
const _hoisted_4 = {
  class: "center"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "首页")], -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "继续教育")], -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "初任培训")], -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "通知公告")], -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "培训指南")], -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", null, "联系方式")], -1));
const _hoisted_11 = {
  class: "right"
};
const _hoisted_12 = {
  class: "right-content"
};
const _hoisted_13 = {
  key: 0,
  class: "login-button"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RouterLink = _resolveComponent("RouterLink");
  const _component_el_avatar = _resolveComponent("el-avatar");
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_router_link = _resolveComponent("router-link");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_Login = _resolveComponent("Login");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("nav", _hoisted_2, [_hoisted_3, _createElementVNode("nav", _hoisted_4, [_createVNode(_component_RouterLink, {
    to: "/"
  }, {
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  }), _createVNode(_component_RouterLink, {
    to: "/educate"
  }, {
    default: _withCtx(() => [_hoisted_6]),
    _: 1
  }), _createVNode(_component_RouterLink, {
    to: "/exercise"
  }, {
    default: _withCtx(() => [_hoisted_7]),
    _: 1
  }), _createVNode(_component_RouterLink, {
    to: "/article"
  }, {
    default: _withCtx(() => [_hoisted_8]),
    _: 1
  }), _createVNode(_component_RouterLink, {
    to: "/guide"
  }, {
    default: _withCtx(() => [_hoisted_9]),
    _: 1
  }), _createVNode(_component_RouterLink, {
    to: "/about"
  }, {
    default: _withCtx(() => [_hoisted_10]),
    _: 1
  })]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [!_ctx.token ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("span", {
    onClick: _cache[0] || (_cache[0] = $event => $options.login())
  }, "登录")])) : _createCommentVNode("", true), _ctx.token ? (_openBlock(), _createBlock(_component_el_dropdown, {
    key: 1
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [_createVNode(_component_router_link, {
        to: "/course"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_dropdown_item, null, {
          default: _withCtx(() => [_createTextVNode("学习中心")]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_router_link, {
        to: "/profile"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_dropdown_item, null, {
          default: _withCtx(() => [_createTextVNode("个人资料")]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_dropdown_item, {
        onClick: $options.logout
      }, {
        default: _withCtx(() => [_createTextVNode(" 退出登录 ")]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_avatar, {
      src: "https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
    })])]),
    _: 1
  })) : _createCommentVNode("", true)])])])]), $data.showLogin ? (_openBlock(), _createBlock(_component_Login, {
    key: 0,
    onClose: _cache[1] || (_cache[1] = $event => $data.showLogin = false)
  })) : _createCommentVNode("", true)], 64);
}